import React, { useEffect, useState, useCallback, useRef, useMemo, memo } from "react";
import {
  Button,
} from "reactstrap";
import dayjs, { Dayjs } from "dayjs";
import audioUrl from "../../../assets/files/hotel-bell.mp3";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";
import widgetTimeTable from "../../../assets/images/icons-component/timetable.png";

import Activity from "./Activity";

import { screenState, setError } from "../../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const dispatch = useAppDispatch();
  const { username } = useAppSelector(state => screenState(state));
  const { config, boxRef, openOption, onUpdate, actionEnd } = props;
  const [timeTableTitle, setTimeTableTitle] = useState<any>("");
  const [activities, setActivities] = useState<any>([]);
  const [currentTime, setCurrentTime] = useState<Dayjs>(dayjs());
  const [currentActivityIndex, setCurrentActivityIndex] = useState<number | null>(null);
  const audio = useMemo(() => new Audio(audioUrl), [audioUrl]);

  useEffect(() => {
    let timer: any = null;
    if (config.data.listType === "timetable") {
      timer = setInterval(() => {
        setCurrentTime(dayjs());
      }, 1000);
    }
    if (timer && config.data.listType === "checklist") {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [config.data.listType]);
  
  useEffect(() => {
    setCurrentActivityIndex(null);
    setTimeTableTitle(config.data.listTitle);
    const hour = config.data.firstTime.hour;
    const minutes = config.data.firstTime.minutes;
    let firstTime = dayjs().hour(hour).minute(minutes);

    if (config.data.timeTable.length !== 0) {
      const tempArray = [...config.data.timeTable];
      const newArray = tempArray.map((item, index) => {
        const startTime = firstTime.format('HH:mm');
        const endTime = firstTime.add(item.duration, 'minute').format('HH:mm');
        const ampm = firstTime.add(item.duration, 'minute').format('A');

        const isCurrentTimeInRange = CurrentTimeInRangeGet(startTime, endTime, currentTime);
      
        firstTime = firstTime.add(item.duration, 'minute');
      
        return {
          id: item.id,
          type: item.type,
          name: item.title,
          duration: item.duration,
          checked: item.checked,
          startTime: startTime,
          endTime: endTime,
          ampm: ampm,
          isActive: isCurrentTimeInRange,
          onReady: checkActivityStatus(startTime, endTime)
        };
      });
      setActivities(newArray);
      // 

      const activeData = config.data.timeTable.filter((item: any) => item.type === "active");
      const activeLength = activeData.length;
      // const scale = Number(boxRef.current.style.width.split('px')[0]) / 340;
      const scale = Number(boxRef.current.style.height.split('px')[0]) / config.baseHeight;
      if (config.data.listTitleShow) {
        boxRef.current.style.height = ((activeLength * 80) + 65) / scale;
        const height = ((activeLength * 80) + 65) / scale;
        const basehegiht = (activeLength * 80) + 20 + 45;
        onUpdate({
          id: config.id,
          height: height * scale * scale,
          baseHeight: basehegiht,
          minHeight: (activeLength * 40) + 32,
          minWidth: 170
        });
      } else {
        boxRef.current.style.height = ((activeLength * 80) + 20) / scale;
        const height = ((activeLength * 80) + 20) / scale;
        const basehegiht = (activeLength * 80) + 20;
        onUpdate({
          id: config.id,
          height: height * scale * scale,
          baseHeight: basehegiht,
          minHeight: (activeLength * 40) + 10,
          minWidth: 170
        });
      }
    } else {
      boxRef.current.style.height = boxRef.current.style.width / 1.511111111111111;
      const height = config.width / 1.511111111111111;
      onUpdate({
        id: config.id,
        height: height,
        baseHeight: 300,
        minHeight: 112,
        minWidth: 170
      });
    }
  }, [config.data]);

  useEffect(() => {
    if (activities.length !== 0) {
      const newActivities = [...activities];
      const newCurrentActivityIndex = newActivities.findIndex((activity: any) => {
        return CurrentTimeInRangeGet(activity.startTime, activity.endTime, currentTime);
      });

      newActivities.findIndex((activity: any, index: number) => {
        if (newCurrentActivityIndex !== index) {
          activity.isActive = false;
        }        
        activity.onReady = checkActivityStatus(activity.startTime, activity.endTime);
      });
      
      if (newCurrentActivityIndex >= 0 && newCurrentActivityIndex !== currentActivityIndex) {
        const currentActivity = activities[newCurrentActivityIndex];
        currentActivity.isActive = true;

        const oldActivity = currentActivityIndex !== null && currentActivityIndex >= 0
                              ? activities[currentActivityIndex]
                              : activities[newCurrentActivityIndex > 0 ? newCurrentActivityIndex - 1 : activities.length - 1];
        if (oldActivity && activities[newCurrentActivityIndex].type === "active") {
          const end = dayjs().set('hour', parseInt(oldActivity.endTime.split(':')[0])).set('minute', parseInt(oldActivity.endTime.split(':')[1])).second(0);
          const diffInSeconds = currentTime.diff(end, 'second');
  
          if (diffInSeconds >= -1 && diffInSeconds <= 1) {
            try {
              audio.volume = 1;
              audio.play();
            } catch (error) {
              console.log(error);
              
            }
          }
        }
        
        setActivities(newActivities);
        setCurrentActivityIndex(newCurrentActivityIndex);
      }
    }
  }, [currentTime, activities, currentActivityIndex]);

  const CurrentTimeInRangeGet = (startTime: string, endTime: string, currentTime: Dayjs) => {
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);
    const start = dayjs().hour(startHour).minute(startMinute).second(0);
    const end = dayjs().hour(endHour).minute(endMinute).second(0);
    return currentTime.isAfter(start) && currentTime.isBefore(end);
  }

  const checkActivityStatus = (startTime: string, endTime: string) => {
    const now = dayjs();
    const start = dayjs().set('hour', parseInt(startTime.split(':')[0])).set('minute', parseInt(startTime.split(':')[1])).second(0);
    const end = dayjs().set('hour', parseInt(endTime.split(':')[0])).set('minute', parseInt(endTime.split(':')[1])).second(0);
  
    return now.isBefore(start) && now.isBefore(end);
  };
  
  const onClickCheckbox = (e: any, index: number) => {
    const data = config.data;
    const newTimeArray = [...data.timeTable];
    newTimeArray[index].checked = e.target.checked;
    data.timeTable = newTimeArray;
    onUpdate({
      id: config.id,
      data: { ...data }
    });
    actionEnd(true);
  };
  
  // useEffect(() => {
  //   const DATA = config.data;
  //   if (config.data?.triggered) {
  //     setData(DATA.linkList);
  //     delete config.data.triggered;
  //   } else if (config.data && config.data.linkList) {
  //     DATA.linkList = data;
  //     const listTitle = activeLength > 0 && data[0].title !== ""? data[0].title : link;
  //     const update: any = { id: config.id, data: DATA };
  //     if (listTitle !== "") {
  //       update["listTitle"] = listTitle;
  //     }
  //     if ((!username && !config?.studentName) || username === config.studentName) {
  //       onUpdate(update);
  //       actionEnd(true);
  //     }
  //   }
  // }, [data, config.data]);

  return (
    <React.Fragment>
      <div className={`${props.mobile? "timetable-scroll" : ""}`} style={{ height: '100%', width: '100%', position: 'absolute' }}>
        {config.data.timeTable.length !== 0? (
          <div className="timeTable-component">
            {config.data.listTitleShow? (
              <div className="timeTable-title">
                {timeTableTitle? timeTableTitle : "今日要做什麼?"}
              </div>
            ) : null}
            {activities.map((item: any, index: number) => (
              item.type === "active" ? (
                <Activity 
                  activity={item}
                  currentTime={currentTime}
                  showTitle={config.data?.listTitleShow}
                  index={index}
                  listType={config.data.listType}
                  onchangeChecked={onClickCheckbox}
                  key={item.id}
                />
              ) : null
            ))}
          </div>
        ) : (
          <div className="relative flex h-full flex-col items-center justify-center p-6 bg-screen  overflow-hidden" style={{ cursor: 'auto' }}>
            <div className="widget-head">
              <img className="widget-img-icon" src={widgetTimeTable} alt="" />
            </div>
            <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">時程表</p>
            <Button
              color="light"
              className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
              onClick={(e: any) => {openOption()}}
              data-interaction-target-type="false"
            >
              <div className="relative justify-center h-100 w-100">
                <span className="flex items-center justify-center w-100">
                  設定
                </span>
              </div>
            </Button>
          </div>

          // <div className="h-100">
          //   <div className="bg-screen h-100 " style={{ textAlign: "center" }}>
          //     <div className="countdown-box">
          //       <div className="w-100">
          //         <img className="widget-img-icon" src={widgetTimeTable} alt="" />
          //       </div>
          //       <p>時程表</p>
          //       <div style={{ height: "44px" }}>
          //         <Button
          //           color="light"
          //           className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
          //           onClick={(e: any) => {openOption()}}
          //           data-interaction-target-type="false"
          //         >
          //           <div className="relative justify-center h-100 w-100">
          //             <span className="flex items-center justify-center w-100">
          //               設定
          //             </span>
          //           </div>
          //         </Button>
          //       </div>
          //     </div>
          //   </div>
          // </div>
        )}
      </div>
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);